document.addEventListener('DOMContentLoaded', function () {
  const initLoopSliders = () => {
    const sections = document.querySelectorAll('.center-focus-slider-wrapper');
    
    sections.forEach(section => {
      const track = section.querySelector('.slider-track');
      const viewport = section.querySelector('.slider-track-viewport');
      let originalCards = Array.from(section.querySelectorAll('.slider-card'));
      const prevBtn = section.querySelector('.prev-btn');
      const nextBtn = section.querySelector('.next-btn');
      
      if (!track || originalCards.length === 0) return;

      track.querySelectorAll('.cloned').forEach(el => el.remove());

      const countToClone = Math.max(5, originalCards.length);
      
      for (let i = 0; i < countToClone; i++) {
        const cloneFirst = originalCards[i % originalCards.length].cloneNode(true);
        cloneFirst.classList.add('cloned');
        track.appendChild(cloneFirst);
      }

      for (let i = 0; i < countToClone; i++) {
        const reverseIndex = (originalCards.length - 1 - (i % originalCards.length));
        const cloneLast = originalCards[reverseIndex].cloneNode(true);
        cloneLast.classList.add('cloned');
        track.insertBefore(cloneLast, track.firstChild);
      }

      const allCards = Array.from(section.querySelectorAll('.slider-card'));
      const totalOriginals = originalCards.length;
      
      let currentIndex = countToClone; 
      let isTransitioning = false;

      const updateSliderPosition = (animate = true) => {
        if (animate) {
          track.style.transition = 'transform 0.5s cubic-bezier(0.25, 1, 0.5, 1)';
          isTransitioning = true;
        } else {
          track.style.transition = 'none';
        }

        const activeCard = allCards[currentIndex];
        const viewportWidth = viewport.offsetWidth;
        const cardWidth = activeCard.offsetWidth;
        
        const offset = activeCard.offsetLeft - (viewportWidth / 2) + (cardWidth / 2);
        track.style.transform = `translateX(${-offset}px)`;

        const activeDataIndex = parseInt(activeCard.getAttribute('data-index'));
        allCards.forEach((card) => {
          const cardDataIndex = parseInt(card.getAttribute('data-index'));
          card.classList.toggle('is-active', cardDataIndex === activeDataIndex);
        });
      };

      track.addEventListener('transitionend', () => {
        isTransitioning = false;
        if (currentIndex >= totalOriginals + countToClone) {
          currentIndex = currentIndex - totalOriginals;
          updateSliderPosition(false);
        } else if (currentIndex < countToClone) {
          currentIndex = currentIndex + totalOriginals;
          updateSliderPosition(false);
        }
      });

      nextBtn?.addEventListener('click', () => {
        if (isTransitioning) return;
        currentIndex++;
        updateSliderPosition(true);
      });

      prevBtn?.addEventListener('click', () => {
        if (isTransitioning) return;
        currentIndex--;
        updateSliderPosition(true);
      });

      let isDragging = false;
      let startX = 0;
      let currentX = 0;
      let initialOffset = 0;

      const getPositionX = (e) => {
        return e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
      };

      const dragStart = (e) => {
        if (isTransitioning) return;
        isDragging = true;
        startX = getPositionX(e);
        track.style.transition = 'none';
        
        const transformMatrix = window.getComputedStyle(track).transform;
        if (transformMatrix !== 'none') {
          initialOffset = parseFloat(transformMatrix.split(',')[4]);
        }

        if (e.type === 'mousedown') {
          e.preventDefault();
        }
      };

      const dragMove = (e) => {
        if (!isDragging) return;
        currentX = getPositionX(e);
        const diff = currentX - startX;
        track.style.transform = `translateX(${initialOffset + diff}px)`;
      };

      const dragEnd = (e) => {
        if (!isDragging) return;
        isDragging = false;
        const diff = currentX - startX;
        const threshold = e.type.includes('touch') ? 60 : 90;

        if (diff < -threshold) {
          currentIndex++;
        } else if (diff > threshold) {
          currentIndex--;
        }
        
        updateSliderPosition(true);
      };

      viewport.addEventListener('mousedown', dragStart);
      viewport.addEventListener('mousemove', dragMove);
      window.addEventListener('mouseup', dragEnd);
      viewport.addEventListener('mouseleave', dragEnd);

      viewport.addEventListener('touchstart', dragStart, { passive: true });
      viewport.addEventListener('touchmove', dragMove, { passive: true });
      viewport.addEventListener('touchend', dragEnd);

      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          updateSliderPosition(false);
        }, 100);
      });
      
      setTimeout(() => updateSliderPosition(false), 50);
      window.addEventListener('load', () => {
        updateSliderPosition(false);
      });
      
      const images = section.querySelectorAll('img');
      let loadedImagesCount = 0;
      images.forEach(img => {
        if (img.complete) {
          loadedImagesCount++;
        } else {
          img.addEventListener('load', () => {
            loadedImagesCount++;
            if (loadedImagesCount === images.length) {
              updateSliderPosition(false);
            }
          });
        }
      });
    });
  };

  initLoopSliders();
  document.addEventListener('shopify:section:load', initLoopSliders);
});